import { render, staticRenderFns } from "./StatsTiles.vue?vue&type=template&id=1885bb80&"
import script from "./StatsTiles.vue?vue&type=script&lang=ts&"
export * from "./StatsTiles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports